<template>
  <Tabs
    v-model="currentTab"
    class="tw:flex tw:flex-row"
  >
    <Tab
      class="tw:flex tw:flex-1"
      :label="
        getLocaleText(
          'social_integration_refresh_integrations.existing_integrations'
        )
      "
      name="existing"
    />
    <Tab
      class="tw:flex tw:flex-1"
      :label="
        getLocaleText('social_integration_refresh_integrations.add_accounts')
      "
      name="new"
    />
  </Tabs>
  <SocialIntegrationRefreshIntegrationList
    v-show="currentTab === 'existing'"
    v-model:selected-integrations="selectedExistingIntegrations"
    identifier="id"
    :integration-type="props.type"
    :integrations="existingIntegrations"
    list-type="existing"
    @update:selected-integrations="selectedExistingIntegrationsChanged"
  />
  <SocialIntegrationRefreshIntegrationList
    v-show="currentTab === 'new'"
    v-model:selected-integrations="selectedNewIntegrations"
    identifier="remoteId"
    :integration-type="props.type"
    :integrations="newIntegrations"
    list-type="new"
    @update:selected-integrations="selectedNewIntegrationsChanged"
  />
</template>

<script setup lang="ts">
import { type Ref, computed, ref } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { Tab, Tabs } from "shared/components/base";
import SocialIntegrationRefreshIntegrationList from "shared/components/integrations/SocialIntegrationRefreshIntegrationList.vue";
import {
  type PLATFORM_LABELS,
  type SocialIntegration,
} from "shared/constants/social";

interface SocialIntegrationRefreshIntegrationsProps {
  refreshedIntegrations: SocialIntegration[];
  type: keyof typeof PLATFORM_LABELS;
}

const props = defineProps<SocialIntegrationRefreshIntegrationsProps>();
const currentTab = ref<string>("existing");

const emit = defineEmits<{
  "selected-integrations-updated": [SocialIntegration[]];
}>();

const selectedExistingIntegrations = ref([]) as Ref<SocialIntegration[]>;

const selectedNewIntegrations = ref([]) as Ref<SocialIntegration[]>;

const existingIntegrations = computed<SocialIntegration[]>(() =>
  props.refreshedIntegrations.filter((integration) => integration.id)
);

const newIntegrations = computed<SocialIntegration[]>(() =>
  props.refreshedIntegrations.filter((integration) => !integration.id)
);

function selectedExistingIntegrationsChanged(
  integrations: SocialIntegration[]
) {
  const allSelectedIntegrations = [
    ...selectedNewIntegrations.value,
    ...integrations,
  ];

  emit("selected-integrations-updated", allSelectedIntegrations);
}

function selectedNewIntegrationsChanged(integrations: SocialIntegration[]) {
  const allSelectedIntegrations = [
    ...selectedExistingIntegrations.value,
    ...integrations,
  ];

  emit("selected-integrations-updated", allSelectedIntegrations);
}
</script>
